<template>
  <div class="updatePwd">
    <h1>修改密码</h1>
    <p class="page-description">修改成功后需要重新登录，请妥善保管新密码。</p>
    <div class="flex-inp">
      <label for="current-password">原密码</label>
      <input id="current-password" type="password" autocomplete="current-password" placeholder="请输入原密码" v-model.trim="oldPwd"/>
    </div>
    <div class="flex-inp">
      <label for="new-password">新密码</label>
      <input id="new-password" type="password" autocomplete="new-password" placeholder="请输入新密码" v-model.trim="newPwd"/>
    </div>
    <div class="flex-inp">
      <label for="confirm-password">确认密码</label>
      <input id="confirm-password" type="password" autocomplete="new-password" placeholder="请再次输入新密码" v-model.trim="againNewPwd"/>
    </div>
    <button class="btn" @click="confirm">保存新密码</button>
  </div>
</template>

<script>
import { updatePwd } from '@/api/common'

export default {
  data () {
    return {
      oldPwd: '',
      newPwd: '',
      againNewPwd: ''
    }
  },
  methods: {
    async confirm () {
      if (!this.oldPwd || !this.newPwd || !this.againNewPwd) {
        this.$toast.fail('请输入完整数据')
        return
      }

      if (this.newPwd !== this.againNewPwd) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
        return
      }
      const result = await updatePwd(this.oldPwd, this.newPwd, this.againNewPwd)
      this.$toast.success(result.data)
      // 密码修改成功后退出登录
      this.$store.commit('removeUserInfo')
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err // 重新抛出其他类型的错误
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.updatePwd {
  margin: 50px auto;
  width: 500px;
  height: 500px;
  padding: 30px;
  .flex-inp {
    display: flex;
    margin: 20px 0;
    span {
      width: 20%;
      line-height: 32px;
    }
    input {
      width: 80%;
      height: 32px;
      padding: 4px 7px;
      font-size: 14px;
      border: 1px solid #dcdee2;
      border-radius: 4px;
      color: #515a6e;
      background-color: #fff;
      background-image: none;
      cursor: text;
    }
  }
  .btn {
    width: 100%;
    height: 35px;
    text-align: center;
    cursor: pointer;
    padding: 0 15px;
    font-size: 16px;
    border-radius: 4px;
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
    margin-top: 10px;
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .updatePwd {
    margin: 20px auto;
    width: 100%;
    padding: 15px;
    height: auto;

    .flex-inp {
      margin: 15px 0;

      span {
        width: 80px;
        font-size: 14px;
      }

      input {
        flex: 1;
        height: 36px;
        font-size: 14px;
      }
    }

    .btn {
      height: 40px;
      font-size: 15px;
    }
  }
}
</style>
